// These are constant values sent from Backend
// Shown as toast
export const USER_HAS_NO_ADDRESS = 'user_has_no_address';
export const USER_HAS_NO_DATE_OF_BIRTH = 'user_has_no_date_of_birth';
// Shown under label
export const INVALID_ROUTING_NUMBER = 'invalid_routing_number';
export const INVALID_ACCOUNT_NUMBER = 'invalid_account_number';
export const USER_HAS_NOT_ACCEPTED_TOS = 'user_has_not_accepted_tos';
